import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_PETITION_AI_GUIDANCE = defineFcm(
	'starter_experience_dashboard_petition_ai_guidance',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_ai_guidance_a_a',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description: 'Controls the visibility of the feature.',
		deprecated:
			'AI guidance experiment retired (CHANGE-98056) — front-end usage removed; safe to delete after 2026-09-22',
		import: false,
		template: {
			experimentName: 'starter_experience_ai_guidance_a_a',
			enabled: false,
		},
	});
